// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__VDQYm","signatureButtonsRight":"ModalSign_signatureButtonsRight__1TPc_"};